import React, { useContext, useState } from 'react';
import { Context } from "../contexts/AppContext";
import { putData } from '../../lib/utils';
import { useParams } from 'react-router-dom';

function FontDropDown() {
  const [openHeading, setOpenHeading] = useState(false);  // "Heading" dropdown ke liye alag state
  const [openBody, setOpenBody] = useState(false);        // "Body" dropdown ke liye alag state
  const { value } = useContext(Context);
  const [appState, setAppState] = value;  
  const [selectedHeadingFont, setSelectedHeadingFont] = useState(appState.currentFontFamilyVideoTitle);  // Heading font ke liye selected font state
  const [selectedBodyFont, setSelectedBodyFont] = useState(appState.currentFontFamilyVideoSubTitle);        // Body font ke liye selected font state

  
  
 
      const { galleryId } = useParams();

  const arrFontFamily = [
  "Arial",
  "Helvetica",
  "Verdana",
  "Tahoma",
  "Trebuchet MS",
  "Times New Roman",
  "Georgia",
  "Garamond",
  "Courier New",
  "Brush Script MT",
  "Lucida Console",
  "Lucida Sans Unicode",
  "Impact",
  "Palatino Linotype"
];

  
  

  const handleFontSelect = async(font, type) => {
    //console.log(`${type} font selected: ${font}`);
    // Font select hone par dropdown ko band karna aur font ko set karna
     
    if (type === 'heading') {
      setSelectedHeadingFont(font);  // Heading font ko set karna
      setOpenHeading(false);         // Dropdown band karna
 
      try {
        const json = await putData(`galleries/update-gallery-title/`, {
          fheading: font,
          
          galleryId: galleryId,
        });
  
        if (json) {
          console.log("JSON =====", json);
          
          setAppState((prevState) => ({
            ...prevState,
            currentFontFamilyVideoTitle: json.gallery.fheading,
            currentFontFamilyVideoSubTitle: json.gallery.fbody,
            currentGalleryName: json.gallery?.name || "",
            currentGalleryVideoTitle: json.gallery?.title || "",
            currentGalleryVideoSubTitle: json.gallery?.subtitle || "",
          }));
  
      
        }
      } catch (error) {
        console.error("Error updating gallery title:", error);
      }
       
     
    } else {
      setSelectedBodyFont(font);    // Body font ko set karna
      setOpenBody(false);           // Dropdown band karna

      try {
        const json = await putData(`galleries/update-gallery-title/`, {
          fbody: font,          
          galleryId: galleryId,
        });
  
        if (json) {
          console.log("JSON =====", json);
          
          setAppState((prevState) => ({
            ...prevState,
            currentFontFamilyVideoTitle: json.gallery.fheading,
            currentFontFamilyVideoSubTitle: json.gallery.fbody,
            currentGalleryName: json.gallery?.name || "",
            currentGalleryVideoTitle: json.gallery?.title || "",
            currentGalleryVideoSubTitle: json.gallery?.subtitle || "",
          }));
  
      
        }
      } catch (error) {
        console.error("Error updating gallery title:", error);
      }
      
    }

   
  };

  return (
    <div className='space-y-4'>
      {/* Heading Dropdown */}
      <div className="relative inline-block text-left">
        <div className='py-2'>Heading</div>
        <button
          onClick={() => setOpenHeading(!openHeading)}  // Heading dropdown ka state toggle karenge
          className="inline-flex w-full min-w-[160px] justify-between items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100"  // Added flex layout and justify-between
        >
          {selectedHeadingFont ? selectedHeadingFont : "Choose Your Font"}  {/* Agar font select hua hai toh wo display hoga, nahi toh default text */}
          <svg className="ml-2 -mr-1 h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        {openHeading && (
          <div className="absolute max-h-32 overflow-y-auto z-10 mt-2 w-full origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5">
            <div className="py-1">
              {arrFontFamily.map((val) => (
                <a
                  
                  key={val}
                  onClick={() => handleFontSelect(val, 'heading')}  // Font select karne par handler call karenge
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  {val}
                </a>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Body Dropdown */}
      <div className="relative inline-block text-left">
        <div className='py-2'>Body</div>
        <button
          onClick={() => setOpenBody(!openBody)}  // Body dropdown ka state toggle karenge
          className="inline-flex w-full min-w-[160px] justify-between items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100"  // Added flex layout and justify-between
        >
          {selectedBodyFont ? selectedBodyFont : "Choose Your Font"}  {/* Agar font select hua hai toh wo display hoga, nahi toh default text */}
          <svg className="ml-2 -mr-1 h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        {openBody && (
          <div className="absolute max-h-32 overflow-y-auto z-10 mt-2 w-full origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5">
            <div className="py-1">
              {arrFontFamily.map((val) => (
                <a
                 
                  key={val}
                  onClick={() => handleFontSelect(val, 'body')}  // Font select karne par handler call karenge
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  {val}
                </a>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default FontDropDown;
